const site = site || {};
site.Utilities = (() => {
    // Functions

    const toggleHamburgerIcon = (mediaQueries) => {
        const toggleNav = document.getElementById('js-toggle-nav');

        toggleNav.addEventListener('mouseup', (e) => {
            toggleNav.classList.toggle('animate');
            offcanvasTopPosition(mediaQueries);
        });
    }

    const offcanvasTopPosition = (mediaQueries) => {
        if(!mediaQueries.xl.matches){
            const header = document.getElementById('js-header');
            const siteLogo = document.getElementById('js-site-logo');
            const cookieConsent = document.getElementById('js-cookie-consent');
            const cookieConsentHeight = cookieConsent.offsetHeight;
            const headerHeight = header.offsetHeight;
            const offCanvas = document.getElementById('offcanvasPrimary');

            if (siteLogo.complete) {
                offCanvas.style.setProperty('top', headerHeight + cookieConsentHeight + 'px');
            } else {
                siteLogo.addEventListener('load', () => {
                    offCanvas.style.setProperty('top', headerHeight + cookieConsentHeight + 'px');
                });
            }
        }
    };

    const underlayBelow = () => {
        const underlayBelowEls = document.querySelectorAll('.js-underlay-below');

        if(underlayBelowEls){
            underlayBelowEls.forEach((el, i) => {
                const siblingHeight = el.parentElement.nextElementSibling.getBoundingClientRect().height;
    
                el.style.paddingBottom = (siblingHeight / 12) + "px";
            })
        }
    }

    const overlayAbove = () => {
        const overlayAboveEls = document.querySelectorAll('.js-overlay-above');

        if (overlayAboveEls) {
            overlayAboveEls.forEach((el, i) => {
                const elHeight = el.getBoundingClientRect().height;
                const section = el.querySelector('section');
                
                if(section) {
                    section.classList.remove('my-5', 'my-md-6');
                    section.classList.add('mb-5', 'mb-md-6');
                }
    
                el.style.marginTop = "-" + (elHeight / 4) + "px";
            })
        }
    }

    const getCookie = (cname) => {
        let name = cname + "=";
        let ca = document.cookie.split(';');

        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];

            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }

            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    const hidePopupBanner = () => {
        const closeTrigger = document.querySelectorAll('.js-remove-popup');

        if (closeTrigger.length > 0) {
            closeTrigger.forEach((el) => {
                const hidePopup = getCookie("popup");

                if (hidePopup == "") {
                    el.parentElement.classList.add('show');
                }

                el.addEventListener('click', () => {
                    document.cookie = "popup=hide; path=/";
                });
            });
        }
    };

    const acceptCookieConsent = (mediaQueries) => {
        const cookie_consent = getCookieConsent("user_cookie_consent");
        const cookieConsent = document.querySelector(".js-cookie-consent");

        if (cookie_consent != "") {
            cookieConsent.classList.add('d-none');
        } else {
            cookieConsent.classList.remove('d-none');
        }

        const acceptBtn = document.querySelector('.js-cookie-accept');
        const btnClose = document.querySelector('.js-cookie-close');
    
        // Set cookie consent
        acceptBtn.addEventListener('click', () => {
            deleteCookieConsent('user_cookie_consent');
            setCookieConsent('user_cookie_consent', 1, 365);
            cookieConsent.classList.add('d-none');
            offcanvasTopPosition(mediaQueries);            
        })
    
        //Close window
        btnClose.addEventListener('click', () => {
            cookieConsent.classList.add('d-none');
            offcanvasTopPosition(mediaQueries);
        })
    }

    // Create cookie
    const setCookieConsent = (cname, cvalue, exdays) => {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        let expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    // Delete cookie
    const deleteCookieConsent = (cname) => {
        const d = new Date();
        d.setTime(d.getTime() + (24 * 60 * 60 * 1000));
        let expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=;" + expires + ";path=/";
    }

    // Read cookie
    const getCookieConsent = (cname) => {
        const name = cname + "=";
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }    

    const cardAnchor = () => {
        const cardAnchors = document.querySelectorAll('.js-card-anchor');

        if (cardAnchors){
            cardAnchors.forEach((el) => {
                const anchors = el.querySelectorAll("a");
                
                if (anchors) {
                    anchors.forEach((anchor) => {
                        const spanElement = document.createElement('span');

                        anchor.classList.add('stretched-link');
                        spanElement.classList.add('position-relative', 'd-inline-block');
                        spanElement.appendChild(anchor.cloneNode(true));
                        anchor.parentNode.replaceChild(spanElement, anchor);
                    } )
                } 
            })
        }
    }

    // Return
    return {
        // functionName : functionName
        toggleHamburgerIcon : toggleHamburgerIcon,
        offcanvasTopPosition : offcanvasTopPosition,
        underlayBelow : underlayBelow,
        overlayAbove : overlayAbove,
        hidePopupBanner: hidePopupBanner,
        acceptCookieConsent: acceptCookieConsent,
        cardAnchor : cardAnchor
    };
})();